import { render } from "./ChatsActivosContent.vue?vue&type=template&id=259aab64&ts=true"
import script from "./ChatsActivosContent.vue?vue&type=script&lang=ts"
export * from "./ChatsActivosContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__